const prefix = 'src/redux/settings/'

export const GET_SETTING_LIST = `${prefix}list/get`
export const GET_SETTING_DETAIL = `${prefix}details/get`
export const POST_SETTING = `${prefix}post`
export const PUT_SETTING = `${prefix}put`
export const RESET_SETTING_STATE = `${prefix}reset`
export const DELETE_SETTING = `${prefix}delete`